export const CLEANUP_SEARCH_STATE = 'cleanup-search-state';
const cleanupSearchState = () => ({ type: CLEANUP_SEARCH_STATE });
export default cleanupSearchState;
